import Vue from 'vue'

const newTab = (link: string): Object | null => {
  const tabRef = window.open()
  if (tabRef) {
    (tabRef.location as any) = link
    return tabRef
  } else return null
}

const appNewTab = (vm: { $router: { resolve: (arg0: { path: any }) => any } }, path: any) => {
  const route = vm.$router.resolve({ path: path })
  Vue.prototype.$utils.browser.newTab(route.href)
}

const getElementByClass = (classes: string) => {
  const elements = document.getElementsByClassName(classes)
  if ('length' in elements && elements.length > 0) {
    if (elements.length > 1) {
      console.warn(`Tried to get element by class "${classes}", there is more than one, but only one is returned.`)
    }

    return elements[0]
  } else {
    console.warn(`Tried to get element by class "${classes}" but there are none...`)
  }

  return null
}

export const getElementHeight = (elementID: string) => {
  const element = document.getElementById(elementID)
  if (element) {
    const elementTop = element.getBoundingClientRect().top || 0
    const documentTop = document.body.getBoundingClientRect().top || 0
    return elementTop  - documentTop
  }
  return 0
}

export const smoothScroll = function(elementY: number, duration: number) {
  const startingY = window.pageYOffset
  const diff = elementY - startingY
  let start: number

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp: number) {
    if (!start) start = timestamp
    // Elapsed milliseconds since start of scrolling.
    const time = timestamp - start
    // Get percent of completion in range [0, 1].
    const percent = Math.min(time / duration, 1)

    window.scrollTo(0, startingY + diff * percent)

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}

export const smoothlyGoTo = (elementId: string) => {
  const y = getElementHeight(elementId)
  console.log('elementHeight is', y, elementId)
  smoothScroll(y - 160, 600)
}

const confirmationDialog = (vs: { dialog: (arg0: { type: string; color: string; title: string; acceptText: string; cancelText: string; text: any; accept: any; cancel: undefined; close: undefined }) => any }, message: any, accept: any, cancel = undefined, close = undefined) => {
  return vs.dialog({
    type: 'confirm',
    color: 'danger',
    title: 'Atenção',
    acceptText: 'Sim',
    cancelText: 'Não',
    text: message,
    accept,
    cancel,
    close
  })
}

/**
 * Normalaize URL
 *
 * @param start
 * @param end
 * @returns
 */
const  normalizeUrl = (start: string, end?: string) => {
  const combined = end !== undefined ? `${start}/${end}` : start;
  return combined.replace(/([^:]\/)\/+/g, '$1');
}

const forceDownload = async (url: string, fileName: string, mimeType: string = 'application/octet-stream') => {
  const normalizedUrl = normalizeUrl(url)

  try {
    const response = await fetch(normalizedUrl, { credentials: 'include' })
    if (!response.ok) {
      throw new Error(`Download failed: ${response.status}`)
    }

    const blob = await response.blob()
    const finalBlob = mimeType && mimeType !== blob.type
      ? new Blob([blob], { type: mimeType })
      : blob

    const blobURL = URL.createObjectURL(finalBlob)
    const link = document.createElement('a')
    link.href = blobURL
    link.download = fileName || 'download'
    link.rel = 'noopener noreferrer'
    link.style.display = 'none'

    document.body.appendChild(link)
    link.click()

    setTimeout(() => {
      document.body.removeChild(link)
      URL.revokeObjectURL(blobURL)
    }, 100)
    return
  } catch (error) {
    // Fallback para download direto (ex.: URLs públicas ou bloqueio de CORS)
    const link = document.createElement('a')
    link.type = mimeType
    link.href = normalizedUrl
    link.download = fileName || 'download'
    link.rel = 'noopener noreferrer'
    link.style.display = 'none'

    document.body.appendChild(link)
    link.click()
    setTimeout(() => {
      document.body.removeChild(link)
    }, 100)
  }
}

export default {
  newTab,
  appNewTab,
  confirmationDialog,
  // Safe method for getting ONE element by a class name
  getElementByClass,
  smoothlyGoTo,
  smoothScroll,
  getElementHeight,
  normalizeUrl,
  forceDownload
}
